

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const UPDATEDESIGNATION= createAsyncThunk(
  "updateDesignation/updateDesignation",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateDesignationSlice = createSlice({
  name: "updateDesignationSlice",
  initialState: {
    updateDesignation: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateDesignation: (state) => {
        state.updateDesignation.loading = false
        state.updateDesignation.error = false
        state.updateDesignation.data = []
        state.updateDesignation.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEDESIGNATION.fulfilled, (state, action) => {
      state.updateDesignation = {
        ...state.updateDesignation,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEDESIGNATION.pending, (state, action) => {
      state.updateDesignation = {
        ...state.updateDesignation,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEDESIGNATION.rejected, (state, action) => {
      state.updateDesignation = {
        ...state.updateDesignation,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateDesignationAction = {
    UPDATEDESIGNATION,
};

export { updateDesignationAction };
export default updateDesignationSlice.reducer;
export const {setInitialStateOfupdateDesignation} = updateDesignationSlice.actions
